import React, { useState, useEffect } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import "./CSS/HeroSection.css";

import logo from "./IMAGES/Frame 197 (1).png";
import redlogo from "./IMAGES/sapra_logo-removebg-preview 2 (1).png";
import { API_BASE, FILE_BASE } from "../config";
import axios from "axios";
import { GoogleLogin } from "@react-oauth/google";


export default function Hero() {
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [index, setIndex] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!sessionStorage.getItem("token")
  );
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [slides, setSlides] = useState([]);

  const handleUserClick = () => {
    console.log(sessionStorage.getItem("token"));

    const token = sessionStorage.getItem("token");

    if (token) {
      navigate("/orders");
    } else {
      setOpen(true);
    }
  };

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [registerData, setRegisterData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",

    phoneNumber: "",
    city: "",
    state: "",
    address: "",
    pincode: ""
  });

  // ✅ Fetch banners from backend
  useEffect(() => {
    fetch(`${API_BASE}/HeroBanner`)
      .then((res) => res.json())
      .then((data) => {
        // Transform backend → frontend format
        const mapped = data.map((item) => ({
          img: FILE_BASE  + item.imageUrl,
          title: item.title,
          desc: item.description,
          cards: item.cards?.map((c) => ({
            img: FILE_BASE  + c.imageUrl,
            title: c.title,
            desc: c.description,
          })) || [],
        }));

        setSlides(mapped);
      })
      .catch((err) => console.error("Error fetching banners:", err));
  }, []);

  // ✅ Auto slide
  useEffect(() => {
    if (slides.length === 0) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [slides]);


  const handleLogin = async () => {
    try {

      const response = await axios.post(
        `${API_BASE}/auth/login`,
        {
          email: loginData.email,
          password: loginData.password,
        }
      );

      console.log(response.data);

      // GET TOKEN FROM RESPONSE
      const token = response.data.token;

      // SAVE TOKEN
      sessionStorage.setItem("token", token);

      // DECODE JWT
      const payload = JSON.parse(
        atob(token.split(".")[1])
      );

      console.log(payload);

      // CREATE CUSTOMER OBJECT
      const customer = {
        id: payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ],
        email:
          payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
          ],
        name:
          payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
          ],
      };

      console.log(customer);

      // SAVE CUSTOMER
      sessionStorage.setItem(
        "customer",
        JSON.stringify(customer)
      );

      // SAVE EXPIRY
      const expiry =
        new Date().getTime() + 24 * 60 * 60 * 1000;

      sessionStorage.setItem(
        "tokenExpiry",
        expiry
      );

      setIsLoggedIn(true);

      setOpen(false);

      navigate("/orders");

    } catch (error) {

      console.log(error);

      alert(
        error.response?.data?.message ||
        "Login failed"
      );
    }
  };


  const handleRegister = async () => {
    try {

      if (
        registerData.password !==
        registerData.confirmPassword
      ) {
        alert("Passwords do not match");
        return;
      }

      console.log(registerData);

      const response = await axios.post(
        `${API_BASE}/auth/register`,
        {
          name: registerData.name,
          email: registerData.email,
          password: registerData.password,

          // SEND EMPTY VALUES
          phoneNumber: "",
          city: "",
          state: "",
          address: "",
          pincode: ""
        }
      );

      console.log(response.data);

      // GET TOKEN
      const token = response.data.token;

      // GET USER
      const customer = response.data.user;

      // SAVE TOKEN
      sessionStorage.setItem(
        "token",
        token
      );

      // SAVE CUSTOMER
      sessionStorage.setItem(
        "customer",
        JSON.stringify(customer)
      );

      // SAVE EXPIRY
      const expiry =
        new Date().getTime() +
        24 * 60 * 60 * 1000;

      sessionStorage.setItem(
        "tokenExpiry",
        expiry
      );

      setIsLoggedIn(true);

      setOpen(false);

      navigate("/orders");

    } catch (error) {

      console.log(error);

      console.log(error.response?.data);

      alert(
        error.response?.data?.message ||
        error.response?.data ||
        "Registration failed"
      );
    }
  };


  const handleGoogleSuccess = async (credentialResponse) => {
    try {

      const response = await axios.post(
        `${API_BASE}/auth/google-login`,
        {
          idToken: credentialResponse.credential,
        }
      );


      // GET TOKEN FROM RESPONSE
      const token = response.data.token;

      // SAVE TOKEN
      sessionStorage.setItem("token", token);

      // DECODE JWT
      const payload = JSON.parse(
        atob(token.split(".")[1])
      );


      // CREATE CUSTOMER OBJECT
      const customer = {
        id: payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ],
        email:
          payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
          ],
        name:
          payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
          ],
      };


      // SAVE CUSTOMER
      sessionStorage.setItem(
        "customer",
        JSON.stringify(customer)
      );

      // SAVE EXPIRY
      const expiry =
        new Date().getTime() + 24 * 60 * 60 * 1000;

      sessionStorage.setItem(
        "tokenExpiry",
        expiry
      );

      setIsLoggedIn(true);

      setOpen(false);

      navigate("/orders");

    } catch (error) {

      console.log(error);

      alert("Google Login Failed");
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const expiry = sessionStorage.getItem("tokenExpiry");

    if (token && expiry) {

      if (new Date().getTime() > Number(expiry)) {

        sessionStorage.clear();

        setIsLoggedIn(false);

      } else {
        setIsLoggedIn(true);
      }
    }
  }, []);

  if (slides.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <section className="hero">
      {/* Background Image */}
      <img
        key={index}
        src={slides[index].img}
        alt="hero"
        className="hero-bg"
      />

      {/* Navbar */}
      <header className="navbar">
        <nav className="nav-left">
          <NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>
            Home
          </NavLink>

          <NavLink to="/shop" className={({ isActive }) => isActive ? "active" : ""}>
            Shop
          </NavLink>

          <NavLink to="/about" className={({ isActive }) => isActive ? "active" : ""}>
            About
          </NavLink>

          <NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""}>
            Contact
          </NavLink>
        </nav>
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
          <nav className={`nav-left ${menuOpen ? "open" : ""}`}>
            <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>
            <NavLink to="/shop" onClick={() => setMenuOpen(false)}>Shop</NavLink>
            <NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink>
            <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink>
          </nav>
        </div>
        <div className="logo">
          <img src={logo} alt="SaPra Logo" />
        </div>

        <div className="nav-right">
          {/* <span><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" /></svg></span> */}
          <span><svg xmlns="http://www.w3.org/2000/svg" onClick={() => navigate("/cart")} height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M223.5-103.5Q200-127 200-160t23.5-56.5Q247-240 280-240t56.5 23.5Q360-193 360-160t-23.5 56.5Q313-80 280-80t-56.5-23.5Zm400 0Q600-127 600-160t23.5-56.5Q647-240 680-240t56.5 23.5Q760-193 760-160t-23.5 56.5Q713-80 680-80t-56.5-23.5ZM246-720l96 200h280l110-200H246Zm-38-80h590q23 0 35 20.5t1 41.5L692-482q-11 20-29.5 31T622-440H324l-44 80h480v80H280q-45 0-68-39.5t-2-78.5l54-98-144-304H40v-80h130l38 80Zm134 280h280-280Z" /></svg></span>
          <span><svg xmlns="http://www.w3.org/2000/svg" onClick={handleUserClick} height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M367-527q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm296.5-343.5Q560-607 560-640t-23.5-56.5Q513-720 480-720t-56.5 23.5Q400-673 400-640t23.5 56.5Q447-560 480-560t56.5-23.5ZM480-640Zm0 400Z" /></svg></span>
        </div>

        {open && (
          <div className="popup-overlay">
            <div className="popup-box">
              <span
                className="close-btn"
                onClick={() => {
                  setOpen(false);
                  setStep(1);
                }}
              >
                ✕
              </span>

              {/* LOGO */}
              <img src={redlogo} alt="SaPra Logo" className="logo-imgi" />
              <p className="sub-logo">House of Élàn</p>

              {step === 1 ? (
                <>
                  <h2>Sign in</h2>
                  <p className="subtitle-red">Welcome Back to the World of SaPra</p>
                  <label>Email</label>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={loginData.email}
                    onChange={(e) =>
                      setLoginData({
                        ...loginData,
                        email: e.target.value,
                      })
                    }
                  />

                  <div className="password-field">
                    <label>Password</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      value={loginData.password}
                      onChange={(e) =>
                        setLoginData({
                          ...loginData,
                          password: e.target.value,
                        })
                      }
                    />

                    <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7Zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z" fill="#666" />
                          <circle cx="12" cy="12" r="2.5" fill="#666" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M19.8822 4.88134L19.1463 4.14539C18.9383 3.9374 18.5543 3.96941 18.3143 4.25736L15.7541 6.80132C14.602 6.30538 13.3382 6.06538 12.0101 6.06538C8.05798 6.08132 4.6342 8.38529 2.98608 11.6975C2.89006 11.9055 2.89006 12.1614 2.98608 12.3374C3.75402 13.9054 4.90609 15.2015 6.34609 16.1774L4.2501 18.3054C4.0101 18.5454 3.97809 18.9293 4.13813 19.1374L4.87408 19.8733C5.08207 20.0813 5.46606 20.0493 5.70606 19.7613L19.754 5.71345C20.058 5.47358 20.09 5.08962 19.882 4.88161L19.8822 4.88134ZM12.8581 9.71322C12.5861 9.6492 12.2981 9.56925 12.0261 9.56925C10.6661 9.56925 9.57818 10.6573 9.57818 12.0172C9.57818 12.2892 9.64219 12.5771 9.72215 12.8492L8.65003 13.9052C8.33008 13.3452 8.15409 12.7211 8.15409 12.0172C8.15409 9.88924 9.86611 8.17722 11.9941 8.17722C12.6982 8.17722 13.3221 8.3532 13.8821 8.67316L12.8581 9.71322Z" fill="#666666" fill-opacity="0.8" />
                          <path d="M21.0342 11.6974C20.4742 10.5774 19.7381 9.56945 18.8262 8.75342L15.8502 11.6974V12.0174C15.8502 14.1454 14.1382 15.8574 12.0102 15.8574H11.6902L9.80225 17.7454C10.5063 17.8893 11.2422 17.9854 11.9623 17.9854C15.9144 17.9854 19.3382 15.6814 20.9863 12.3532C21.1302 12.1292 21.1302 11.9053 21.0342 11.6973L21.0342 11.6974Z" fill="#666666" fill-opacity="0.8" />
                        </svg>
                      )}
                    </span>
                  </div>
                  <button
                    onClick={handleLogin}
                    className="continue-btn"
                  >
                    Log in
                  </button>

                  <p className="terms">
                    Don’t have an account? <span style={{ cursor: "pointer" }} onClick={() => setStep(2)}
                    >Create New Account</span>
                  </p>
                </>
              ) : (
                <>
                  <h2>Sign up</h2>
                  <p className="subtitle-red">Begin Your Journey with SaPra</p>
                  <label>Email</label>
                  <input
                    type="text"
                    placeholder="Enter your email"
                    value={registerData.email}
                    onChange={(e) =>
                      setRegisterData({
                        ...registerData,
                        email: e.target.value,
                      })
                    }
                  />

                  <label>Username</label>
                  <input
                    type="text"
                    placeholder="Enter your username"
                    value={registerData.name}
                    onChange={(e) =>
                      setRegisterData({
                        ...registerData,
                        name: e.target.value,
                      })
                    }
                  />

                  <div className="password-field">
                    <label> New Password</label>
                    <input
                      type={showNewPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      value={registerData.password}
                      onChange={(e) =>
                        setRegisterData({
                          ...registerData,
                          password: e.target.value,
                        })
                      }
                    />

                    <span className="eye-icon" onClick={() => setShowNewPassword(!showNewPassword)}>
                      {showNewPassword ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7Zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z" fill="#666" />
                          <circle cx="12" cy="12" r="2.5" fill="#666" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M19.8822 4.88134L19.1463 4.14539C18.9383 3.9374 18.5543 3.96941 18.3143 4.25736L15.7541 6.80132C14.602 6.30538 13.3382 6.06538 12.0101 6.06538C8.05798 6.08132 4.6342 8.38529 2.98608 11.6975C2.89006 11.9055 2.89006 12.1614 2.98608 12.3374C3.75402 13.9054 4.90609 15.2015 6.34609 16.1774L4.2501 18.3054C4.0101 18.5454 3.97809 18.9293 4.13813 19.1374L4.87408 19.8733C5.08207 20.0813 5.46606 20.0493 5.70606 19.7613L19.754 5.71345C20.058 5.47358 20.09 5.08962 19.882 4.88161L19.8822 4.88134ZM12.8581 9.71322C12.5861 9.6492 12.2981 9.56925 12.0261 9.56925C10.6661 9.56925 9.57818 10.6573 9.57818 12.0172C9.57818 12.2892 9.64219 12.5771 9.72215 12.8492L8.65003 13.9052C8.33008 13.3452 8.15409 12.7211 8.15409 12.0172C8.15409 9.88924 9.86611 8.17722 11.9941 8.17722C12.6982 8.17722 13.3221 8.3532 13.8821 8.67316L12.8581 9.71322Z" fill="#666666" fill-opacity="0.8" />
                          <path d="M21.0342 11.6974C20.4742 10.5774 19.7381 9.56945 18.8262 8.75342L15.8502 11.6974V12.0174C15.8502 14.1454 14.1382 15.8574 12.0102 15.8574H11.6902L9.80225 17.7454C10.5063 17.8893 11.2422 17.9854 11.9623 17.9854C15.9144 17.9854 19.3382 15.6814 20.9863 12.3532C21.1302 12.1292 21.1302 11.9053 21.0342 11.6973L21.0342 11.6974Z" fill="#666666" fill-opacity="0.8" />
                        </svg>
                      )}
                    </span>
                  </div>
                  <div className="password-field">
                    <label> Confirm Password</label>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm password"
                      value={registerData.confirmPassword}
                      onChange={(e) =>
                        setRegisterData({
                          ...registerData,
                          confirmPassword: e.target.value,
                        })
                      }
                    />

                    <span className="eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                      {showConfirmPassword ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7Zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z" fill="#666" />
                          <circle cx="12" cy="12" r="2.5" fill="#666" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M19.8822 4.88134L19.1463 4.14539C18.9383 3.9374 18.5543 3.96941 18.3143 4.25736L15.7541 6.80132C14.602 6.30538 13.3382 6.06538 12.0101 6.06538C8.05798 6.08132 4.6342 8.38529 2.98608 11.6975C2.89006 11.9055 2.89006 12.1614 2.98608 12.3374C3.75402 13.9054 4.90609 15.2015 6.34609 16.1774L4.2501 18.3054C4.0101 18.5454 3.97809 18.9293 4.13813 19.1374L4.87408 19.8733C5.08207 20.0813 5.46606 20.0493 5.70606 19.7613L19.754 5.71345C20.058 5.47358 20.09 5.08962 19.882 4.88161L19.8822 4.88134ZM12.8581 9.71322C12.5861 9.6492 12.2981 9.56925 12.0261 9.56925C10.6661 9.56925 9.57818 10.6573 9.57818 12.0172C9.57818 12.2892 9.64219 12.5771 9.72215 12.8492L8.65003 13.9052C8.33008 13.3452 8.15409 12.7211 8.15409 12.0172C8.15409 9.88924 9.86611 8.17722 11.9941 8.17722C12.6982 8.17722 13.3221 8.3532 13.8821 8.67316L12.8581 9.71322Z" fill="#666666" fill-opacity="0.8" />
                          <path d="M21.0342 11.6974C20.4742 10.5774 19.7381 9.56945 18.8262 8.75342L15.8502 11.6974V12.0174C15.8502 14.1454 14.1382 15.8574 12.0102 15.8574H11.6902L9.80225 17.7454C10.5063 17.8893 11.2422 17.9854 11.9623 17.9854C15.9144 17.9854 19.3382 15.6814 20.9863 12.3532C21.1302 12.1292 21.1302 11.9053 21.0342 11.6973L21.0342 11.6974Z" fill="#666666" fill-opacity="0.8" />
                        </svg>
                      )}
                    </span>
                  </div>

                  <button
                    className="continue-btn"
                    onClick={handleRegister}
                  >
                    Sign Up
                  </button>

                  <p className="terms">
                    If Already have an account?  <span style={{ cursor: "pointer" }} onClick={() => setStep(1)}
                    >Log in  </span>
                  </p>
                </>
              )}

              <div className="dividerr">OR</div>


              <div className="google-login-wrapper">
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={() => {
                    alert("Google Login Failed");
                  }}
                />
              </div>

            </div>
          </div>
        )}
      </header>

      {/* Content */}
      <div key={index} className="hero-content">
        <h1>{slides[index].title}</h1>
        <p>{slides[index].desc}</p>

        <div className="buttons">
          <button className="btn primary">
            Shop New Arrivals
          </button>
          <button
            className="btn secondary"
            onClick={() => navigate("/shop")}
          >
            Explore Collections
          </button>
        </div>
      </div>

      {/* Cards */}
      <div className="card-stack">
        <div className="card back-card-2">
          <img src={slides[index]?.cards?.[2]?.img} alt="" />
        </div>

        <div className="card back-card-1">
          <img src={slides[index]?.cards?.[1]?.img} alt="" />
        </div>

        <div className="card main-card">
          <img src={slides[index]?.cards?.[0]?.img} alt="" />
          <div className="card-text">
            <h4>{slides[index]?.cards?.[0]?.title}</h4>
            <p>{slides[index]?.cards?.[0]?.desc}</p>
          </div>
        </div>
      </div>
    </section>
  );
}